import { TextInput } from '@core/components/Inputs';
import { useDebounce } from '@fuse/hooks';
import { compraApi } from 'app/services/api/compraApi';
import React, { useState } from 'react';

const onlyNumberRegex = /^\d*$/;

function CompraDocumentoFiscalInput({
  id,
  name,
  onChange,
  onBlur,
  touched,
  required,
  label,
  error,
  value,
  disabled,
  fornecedor,
  compraId,
}) {
  const [warning, setWarning] = useState(false);

  const fetchDocumentoFiscal = async (docFiscal, fornecedor) => {
    const filtroAvancado = { tipoFiltro: 'AVANCADO', documentoFiscal: docFiscal, fornecedorId: fornecedor?.id };
    const search = {
      page: 0,
      filtroAvancado,
      size: 1,
    };

    const response = await compraApi().buscarTodos(search);

    const content = response?.data?.content?.filter((compra) => compra?.id !== compraId);

    if (docFiscal && content?.length > 0 && fornecedor?.id) {
      setWarning(true);
    } else {
      setWarning(false);
    }
  };

  const fetchAsync = useDebounce(
    (documentoFiscal, fornecedor) => {
      fetchDocumentoFiscal(documentoFiscal, fornecedor);
    },
    500,
    {}
  );

  const handleChange = (event, fornecedor) => {
    fetchAsync(event.target.value, fornecedor);
    onChange(event);
  };

  fetchAsync(value, fornecedor);

  return (
    <TextInput
      id={id}
      name={name}
      onChange={(e) => handleChange(e, fornecedor)}
      onBlur={onBlur}
      value={value}
      error={error}
      touched={touched}
      required={required}
      pattern={onlyNumberRegex}
      disabled={disabled}
      fullWidth
      variant="outlined"
      label={label}
      maxLength={15}
      warning={warning ? 'Há outra compra utilizando este documento fiscal' : false}
    />
  );
}

export default CompraDocumentoFiscalInput;
